module.exports = __webpack_public_path__ + "static/media/basic-skin.9264cc62.png";